export const tableWidthsConstants = {
  GET_COLUMNS_WIDTH: 'GET_COLUMNS_WIDTH',
  SET_COLUMNS_WIDTH: 'SET_COLUMNS_WIDTH',
  LOCALSTORAGE_NAME: 'table-width',
}
